import { USER_ROLE } from '~common/enum';
import { inMemoryJWTService } from '~services/jwt.service';

export const isAdminRole = () => {
  const userInfo = inMemoryJWTService.getUserInfo();

  if (!userInfo) return false;
  if (!Array.isArray(userInfo.roles)) return false;

  return userInfo.roles.includes(USER_ROLE.ADMIN);
};

export const isSuperAdminRole = () => {
  const userInfo = inMemoryJWTService.getUserInfo();

  if (!userInfo) return false;
  if (!Array.isArray(userInfo.roles)) return false;

  return userInfo.roles.includes(USER_ROLE.SUPER_ADMIN);
};

export const isDistributorRole = () => {
  const userInfo = inMemoryJWTService.getUserInfo();

  if (!userInfo) return false;
  if (!Array.isArray(userInfo.roles)) return false;

  return (
    !userInfo.roles.includes(USER_ROLE.ADMIN) &&
    userInfo.roles.includes(USER_ROLE.DISTRIBUTOR)
  );
};

export const isLimitedDistributorRole = () => {
  const userInfo = inMemoryJWTService.getUserInfo();

  if (!userInfo) return false;
  if (!Array.isArray(userInfo.roles)) return false;

  return (
    !userInfo.roles.includes(USER_ROLE.ADMIN) &&
    !userInfo.roles.includes(USER_ROLE.DISTRIBUTOR) &&
    userInfo.roles.includes(USER_ROLE.LIMITED_DISTRIBUTOR)
  );
};

export const isSalespersonRole = () => {
  const userInfo = inMemoryJWTService.getUserInfo();

  if (!userInfo) return false;
  if (!Array.isArray(userInfo.roles)) return false;

  return (
    !userInfo.roles.includes(USER_ROLE.ADMIN) &&
    !userInfo.roles.includes(USER_ROLE.DISTRIBUTOR) &&
    !userInfo.roles.includes(USER_ROLE.LIMITED_DISTRIBUTOR) &&
    userInfo.roles.includes(USER_ROLE.SALESPERSON)
  );
};

export const isPartnerRole = () => {
  const userInfo = inMemoryJWTService.getUserInfo();

  if (!userInfo) return false;
  if (!Array.isArray(userInfo.roles)) return false;

  return (
    !userInfo.roles.includes(USER_ROLE.ADMIN) &&
    !userInfo.roles.includes(USER_ROLE.DISTRIBUTOR) &&
    !userInfo.roles.includes(USER_ROLE.LIMITED_DISTRIBUTOR) &&
    userInfo.roles.includes(USER_ROLE.PARTNER)
  );
};

export const isStrictlyPartnerRole = () => {
  const userInfo = inMemoryJWTService.getUserInfo();

  if (!userInfo) return false;
  if (!Array.isArray(userInfo.roles)) return false;

  return (
    !userInfo.roles.includes(USER_ROLE.ADMIN) &&
    !userInfo.roles.includes(USER_ROLE.DISTRIBUTOR) &&
    !userInfo.roles.includes(USER_ROLE.LIMITED_DISTRIBUTOR) &&
    !userInfo.roles.includes(USER_ROLE.SALESPERSON) &&
    userInfo.roles.includes(USER_ROLE.PARTNER)
  );
};

const roleToValidatorMap = new Map<USER_ROLE, () => boolean>([
  [USER_ROLE.PARTNER, isStrictlyPartnerRole],
  [USER_ROLE.SALESPERSON, isSalespersonRole],
  [USER_ROLE.LIMITED_DISTRIBUTOR, isLimitedDistributorRole],
  [USER_ROLE.DISTRIBUTOR, isDistributorRole],
  [USER_ROLE.ADMIN, isAdminRole],
  [USER_ROLE.SUPER_ADMIN, isSuperAdminRole],
]);

export const checkRolesMatchWithPrimaryUserRole = (roles: USER_ROLE[]) => {
  return (
    Array.isArray(roles) &&
    roles.some((role) => {
      const roleValidator = roleToValidatorMap.get(role);
      return roleValidator != undefined && roleValidator();
    })
  );
};
